export default __webpack_public_path__ + "static/media/naturaleza.1403ae42.png";